import CategoryFromSlug from 'src/services/categoryFromSlug';
import { useEffect } from 'react';
import { updateParentMetadata } from 'src/utils/frame';
import { usePluginConfig } from '../../../contexts/pluginContext';
import { findActiveLocation } from '../../../helpers/queryHelper';
import { useRouter } from '../../../hooks/useRouter';

const EXCLUDED_PARAMS = ['utm_source', 'touch', '_gl'];

const cleanupCanonicalUrl = (urlString) => {
  const url = new URL(urlString);
  EXCLUDED_PARAMS.forEach(key => url.searchParams.delete(key));

  return url.toString();
}

const EventListSeoTags = ({ categorySlug }) => {
  const pluginConfig = usePluginConfig();
  const router = useRouter();
  const publisherSettings = pluginConfig.publisherSettings;
  const frameConfig = pluginConfig.frameConfig;
  const hostPageData = pluginConfig.hostPageData;
  const pluginType = frameConfig.type;
  const activeLocation = findActiveLocation(router.query);

  let categoryName;
  if (categorySlug) {
    categoryName = new CategoryFromSlug(pluginConfig.rootCategories, categorySlug).category
      ?.name;
  }
  let title;
  let description;

  if (activeLocation && categoryName && categoryName !== 'All Events') {
    title = `${publisherSettings.publisher.name} - ${categoryName} events near ${activeLocation}`;
    description = `Looking for ${categoryName} events near ${activeLocation}? Find ${categoryName} events in ${activeLocation} with our events ${pluginType}.`;
  } else if (activeLocation) {
    title = `${publisherSettings.publisher.name} - Events near ${activeLocation}`;
    description = `Looking for events near ${activeLocation} ? Find events in ${activeLocation} with our events ${pluginType}.`;
  } else if (categoryName) {
    title = `${publisherSettings.publisher.name} - ${categoryName} events`;
    description = `Looking for ${categoryName} events? Find events in your area with our ${pluginType}.`;
  } else {
    // If we don't have a category or location, we're on the main events page.
    // Use the page title and description from the host page, if available.
    title = hostPageData.pageTitle
      ? hostPageData.pageTitle
      : `${publisherSettings.publisher.name} Events ${pluginType}`;

    description = hostPageData.pageDescription
      ? hostPageData.pageDescription
      : `Looking for things to do? Find events in your area with our events ${pluginType}.`;
  }

  const pageMetadata = {
    title: title,
    description: description,

    // For an event list page, the canonical URL is always going to be URL of the page that is being
    // rendered, so this is a safe default.
    canonicalURL: cleanupCanonicalUrl(window.location.href),
    absoluteHref: window.location.href,
  };

  useEffect(() => {
    updateParentMetadata({
      item: pageMetadata,
      pageTitle: title,
    });
  }, []);
};

export default EventListSeoTags;
